import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import { chapterList } from '@/mocks/comics';

export default function LatestUpdates() {
  const mainComic = comics.find((c) => c.id === 1);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">最新章节，精彩不容错过</p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 whitespace-nowrap"
          >
            更多更新 <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <div className="rounded-lg bg-background-100 border border-background-200/70 overflow-hidden">
              <div className="p-5 border-b border-background-200/70">
                <div className="flex items-center gap-3">
                  <div className="w-14 h-14 rounded-lg overflow-hidden flex-shrink-0">
                    <img
                      src={mainComic?.cover}
                      alt={mainComic?.title}
                      className="w-full h-full object-cover object-top"
                      loading="lazy"
                    />
                  </div>
                  <div className="min-w-0">
                    <h3 className="font-heading text-base font-semibold text-foreground-900">
                      {mainComic?.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-0.5">{mainComic?.author} · {mainComic?.status}</p>
                  </div>
                </div>
              </div>
              <div className="divide-y divide-background-200/50">
                {chapterList.map((chapter, index) => (
                  <Link
                    key={chapter.id}
                    to={`/article/${chapter.id}`}
                    className="flex items-center justify-between px-5 py-3.5 hover:bg-background-200/50 transition-colors duration-150 group"
                  >
                    <div className="flex items-center gap-3 min-w-0">
                      <span className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-medium flex-shrink-0 ${
                        index === 0 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'
                      }`}>
                        {index + 1}
                      </span>
                      <span className="text-sm text-foreground-800 group-hover:text-primary-600 transition-colors duration-200 truncate">
                        {chapter.title}
                      </span>
                    </div>
                    <div className="flex items-center gap-4 flex-shrink-0">
                      <span className="text-xs text-foreground-400">{chapter.date}</span>
                      <span className="text-xs text-foreground-400">
                        {(chapter.views / 10000).toFixed(1)}万阅读
                      </span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-1">
            <div className="rounded-lg bg-background-100 border border-background-200/70 p-5">
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-4">更新公告</h3>
              <div className="flex flex-col gap-3">
                {[
                  { title: '全职法师第1281话预计明日更新', date: '2026-08-05' },
                  { title: '完美世界第961话已更新，速来围观', date: '2026-08-05' },
                  { title: '雪中悍刀行第1041话即将上线', date: '2026-08-04' },
                  { title: '一念永恒第821话热更中', date: '2026-08-04' },
                  { title: '斗破苍穹第861话火爆连载', date: '2026-08-03' },
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-2 pb-3 border-b border-background-200/50 last:border-0 last:pb-0">
                    <div className="w-1.5 h-1.5 rounded-full bg-accent-500 mt-1.5 flex-shrink-0"></div>
                    <div className="min-w-0">
                      <p className="text-sm text-foreground-800 leading-relaxed">{item.title}</p>
                      <p className="text-xs text-foreground-400 mt-1">{item.date}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}